import { Required, Schema, TextField } from "lego-gui-lib";
import { t } from "../../../core/i18n/i18n";
import { api, mainStore } from "../../../core/mainStore";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import { BarringMatrixFK } from "../schema";
import { Auth } from "../../../core/model/auth";

export const BarringMatrixEntrySchema = new Schema({
  fields: [
    {
      name: "barringMatrixRef",
      title: t("hns:barringMatrix:domain"),
      type: BarringMatrixFK,
      readonly: true
    },
    {
      name: "prefix",
      title: t("common:prefix"),
      type: TextField(Required)
    }
  ],
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANY_ADMIN,
    editableRole: Auth.Roles.ADMIN
  }
});

export const BarringMatrixEntrySchemaColumns = BarringMatrixEntrySchema.extend({
  barringMatrixRef: false
});

mainStore.barringMatrixEntry = RemoteChildDataSource.create({
  parent: mainStore.barringMatrix.oneDataSource,
  api: api,
  name: "barringMatrixEntry",
  schema: BarringMatrixEntrySchema,
  url: "/entries",
  commons: mainStore.commons
});
